import * as yup from "yup";
import { MSG } from "../constants/MSG";

export const addCategorySchema = yup.object().shape({
	name: yup
		.string()
		.trim()
		.matches(
			/^[a-zA-Z0-9_ ]*$/,
			"Special characters are not allowed in category name"
		)
		.required(MSG.REQUIRED_CATEGORY_NAME),
	photo: yup.string().required(MSG.REQUIRED_IMAGE),
	emoji: yup.string().required(MSG.REQUIRED_EMOJI),
});

export const updateCategorySchema = yup.object().shape({
	name: yup
		.string()
		.trim()
		.matches(
			/^[a-zA-Z0-9_ ]*$/,
			"Special characters are not allowed in category name"
		)
		.required(MSG.REQUIRED_CATEGORY_NAME),
	photo: yup.string().required(MSG.REQUIRED_IMAGE).nullable(),
	emoji: yup.string().required(MSG.REQUIRED_EMOJI),
});
